export enum InsurancePackageType {
  Basic = 'basic',
  Advanced = 'advanced',
  Vip = 'vip',
  None = 'none',
  Corporation = 'corporation',
}
